import React, { useState, useEffect } from 'react'
// import ChildPic from "../../../../../assets/images/child-round.png";
import { registeredParentList as registeredParentListService } from '../../../AxiosRtk/Settings';
import LoadingIndicator from '../../../../../setup/Loader/LoaderIndicator';
import moment from 'moment';
import DefaultUserPic from "../../../../../assets/images/default-user.svg";

const RegisteredRefferedParents = ({ getLangTranslation }) => {
    const [registeredParentList, setRegisteredParentList] = useState([]);
    const [loader, setLoader] = useState(false);
    useEffect(() => {
        setLoader(true);
        registeredParentListService()
            .then((res) => {
                setRegisteredParentList(res?.data?.result?.list);
            })
            .catch((err) => {
                console.log("registered parent listing catch error ===>>>", err?.response?.data?.message)
            })
            .finally(() => {
                setLoader(false);
            })
    }, [])

    return (
        <div className="table-responsive">
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">{getLangTranslation("ADD_CHILD_NAME", "Name")}</th>
                        <th scope="col">{getLangTranslation("EMAIL", "Email")}</th>
                        <th scope="col">{getLangTranslation("DATE", "Date")}</th>
                        <th scope="col">{getLangTranslation("DEVICE_DETAIL_FIND_DEVICE_STATUS", "status")}</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        registeredParentList?.map((item) => {
                            const { 
                                ParentName, 
                                Email, 
                                ParentReferral, 
                                DateCreated, 
                                countryCode, 
                                typeOfPayment 
                            } = item;
                            return (
                                <tr key={item?.ParentReferral}>
                                    <td>
                                        <div className='d-inline-flex  align-items-center'>
                                            <span className='icon-wrap icon-sm p-0 border-0 me-3'>
                                                <img src={DefaultUserPic} alt='' height={40} width={40}/>
                                            </span>
                                            {
                                                ParentName
                                            }
                                        </div>
                                    </td>
                                    <td>{Email}</td>
                                    <td>{moment(DateCreated).locale('en').format("DD-MMMM-YYYY HH:mm")}</td>
                                    <td>
                                        <span className={`badge-pill ${typeOfPayment === 0 ? 'warning' : 'success'}`}>
                                            <i className='icon-check-round me-1'></i>
                                            {typeOfPayment == 0 ? getLangTranslation("SETTING_REGISTERED_PARENT_TRAIL_MEMBERSHIP", "Trial") : getLangTranslation("SETTING_REGISTERED_PARENT_MEMBERSHIP", "Membership")}
                                        </span>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            {
                loader && (
                    <div className='my-4'>
                        <LoadingIndicator height={20} width={100} color="#339CFF" />
                    </div>
                )
            }

            {
                !loader && registeredParentList?.length === 0 && (
                    <div className='text-center my-4'>
                        --- {getLangTranslation('SETTING_SUBSCRIPTION_DISCOUNT_NO_ONE_HAS_REGISTERED_USING_YOUR_REFERRAL_LINK', 'No registered referrals')} ---
                    </div>
                )
            }

        </div>
    )
}

export default RegisteredRefferedParents